'use client';

import { createTrackedSelector } from 'react-tracked';
import create from 'zustand';

interface NewsletterSignupState {
  open: boolean;
  toggleNewsletterSignup: () => void;
  closeNewsletterSignup: () => void;
}
interface ContactFormState {
  open: boolean;
  contactFormRole: string;
  toggleContactForm: (contactFormRole?: string) => void;
  closeContactForm: () => void;
}

const newsletterStore = create<NewsletterSignupState>((set, get) => ({
  open: false,
  toggleNewsletterSignup: () => {
    set({
      open: !get().open,
    });
  },
  closeNewsletterSignup: () => {
    set({
      open: false,
    });
  },
}));

const contactFormStore = create<ContactFormState>((set, get) => ({
  open: false,
  contactFormRole: undefined,
  toggleContactForm: (contactFormRole?: string) => {
    set({
      open: !get().open,
      contactFormRole: contactFormRole,
    });
  },
  closeContactForm: () => {
    set({
      open: false,
      contactFormRole: undefined,
    });
  },
}));
export const useContactFormStore = createTrackedSelector(contactFormStore);
export const useNewsletterStore = createTrackedSelector(newsletterStore);
